// extracted by mini-css-extract-plugin
module.exports = {"help-center":"help-center___1Tel7"};